/**
 * useTourTrigger · wave-help-tour-mvp · 2026-05-20
 *
 * Mini-pub/sub via CustomEvent pra orquestrar abertura do <Tour /> sem
 * acoplar contexto global novo. AppShell escuta o evento `builder:tour:open`
 * e flipa um `useState`; qualquer ponto da árvore dispara via
 * `openTour()`.
 *
 * Por que CustomEvent em vez de Zustand store novo? O Tour é trigger
 * raríssimo (3 entry points) e curtíssima vida (auto-fecha ao concluir).
 * Não justifica nova store global. Event bus zero-dep que já existe no
 * browser resolve.
 */

import { useEffect } from 'react';

const OPEN_EVENT = 'builder:tour:open';
const CLOSE_EVENT = 'builder:tour:close';

/**
 * Dispara abertura do Tour. Pode ser chamado de qualquer ponto da árvore
 * (WelcomePage CTA, TopBar menu, etc) sem prop drilling.
 */
export function openTour(): void {
  if (typeof window === 'undefined') return;
  window.dispatchEvent(new CustomEvent(OPEN_EVENT));
}

/** Dispara fechamento (raramente usado externamente — Tour fecha sozinho). */
export function closeTour(): void {
  if (typeof window === 'undefined') return;
  window.dispatchEvent(new CustomEvent(CLOSE_EVENT));
}

/**
 * Escuta os eventos. Usado por AppShell pra controlar visibilidade do
 * componente <Tour /> sem props.
 */
export function useTourEvents(
  onOpen: () => void,
  onClose: () => void,
): void {
  useEffect(() => {
    const onOpenHandler = () => onOpen();
    const onCloseHandler = () => onClose();
    window.addEventListener(OPEN_EVENT, onOpenHandler);
    window.addEventListener(CLOSE_EVENT, onCloseHandler);
    return () => {
      window.removeEventListener(OPEN_EVENT, onOpenHandler);
      window.removeEventListener(CLOSE_EVENT, onCloseHandler);
    };
  }, [onOpen, onClose]);
}
